import { render, staticRenderFns } from "./ArticleBulkEditView.vue?vue&type=template&id=3570be88&"
import script from "./ArticleBulkEditView.vue?vue&type=script&lang=js&"
export * from "./ArticleBulkEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports